import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import PrizesV1Section from './PrizesV1Section';
import PrizesV2Section from './PrizesV2Section';
import './PrizesSection.css';

const PrizesSection = () => {
  const [ref, inView] = useInView({
    threshold: 0.2,
    triggerOnce: true
  });

  const [showV2, setShowV2] = useState(false);

  useEffect(() => {
    // Check if we should show V2 (podium) - reveal on 2025-10-06 at 20:00 Saudi time
    const checkTime = () => {
      const now = new Date();
      const targetDate = new Date('2025-10-06T20:00:00+03:00'); // Saudi Arabia timezone
      setShowV2(now >= targetDate);
    };

    checkTime();
    const interval = setInterval(checkTime, 60000); // Check every minute

    return () => clearInterval(interval);
  }, []);

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        delayChildren: 0.3,
        staggerChildren: 0.2
      }
    }
  };

  const cardVariants = {
    hidden: { y: 50, opacity: 0, scale: 0.9 },
    visible: {
      y: 0,
      opacity: 1,
      scale: 1,
      transition: {
        duration: 0.8,
        ease: "easeOut"
      }
    }
  };




  return (
    <section className="prizes-section section" id="prizes">
      <div className="container">
        <motion.div 
          ref={ref}
          className="prizes-content"
          variants={containerVariants}
          initial="hidden"
          animate={inView ? "visible" : "hidden"}
        >
          <motion.h2 className="section-title" variants={cardVariants}>
            الجوائز والتقدير
          </motion.h2>
          
          <motion.p className="prizes-subtitle" variants={cardVariants}>
            احتفالاً بالابتكار والتأثير والتغيير ذي المعنى
          </motion.p>
          
          {/* Conditionally render V1 or V2 based on time */}
          <motion.div variants={cardVariants}>
            {showV2 ? <PrizesV2Section /> : <PrizesV1Section />}
          </motion.div>
          

          
          <motion.div className="additional-perks" variants={cardVariants}>
            <h3>مزايا إضافية لجميع المشاركين</h3>
            <div className="perks-grid">
              <div className="perk-item">
                <div className="perk-icon">🌐</div>
                <div className="perk-content">
                  <h4>فعاليات التواصل</h4>
                  <p>بناء شبكة علاقات قوية مع المطورين والمصممين ورجال الأعمال</p>
                </div>
              </div>
              <div className="perk-item">
                <div className="perk-icon">🎓</div>
                <div className="perk-content">
                  <h4>فرص الإرشاد</h4>
                  <p>التوجيه من الخبراء في مجال التقنية وريادة الأعمال</p>
                </div>
              </div>
              <div className="perk-item">
                <div className="perk-icon">💡</div>
                <div className="perk-content">
                  <h4>ورش عمل متخصصة</h4>
                  <p>تعلم مهارات تقنية متقدمة وتقنيات حديثة من خبراء الصناعة</p>
                </div>
              </div>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default PrizesSection;
